import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withKeys as _withKeys, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-605a80b0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "area-whitelist-container"
};
const _hoisted_2 = {
  class: "area-section"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "section-title"
}, "选择业务区域", -1));

const _hoisted_4 = {
  class: "checkall",
  style: {
    "padding-left": "24px"
  }
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("全选");

const _hoisted_6 = {
  key: 0,
  class: "whitelist-section"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "section-title"
}, "商业流向查看权限", -1));

const _hoisted_8 = {
  class: "whitelist-tools"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode("根据区域匹配负责的商业");

const _hoisted_10 = {
  key: 1,
  class: "whitelist-section"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "section-title"
}, "客户白名单", -1));

const _hoisted_12 = {
  class: "whitelist-tools"
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("新增客户");

const _hoisted_15 = {
  class: "dialog-footer"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("确认");

const _hoisted_18 = {
  class: "customer-search-container"
};
const _hoisted_19 = {
  class: "search-filter"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("搜索");

const _hoisted_21 = {
  class: "pagination-container"
};

const _hoisted_22 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_23 = /*#__PURE__*/_createTextVNode("确定");

import { computed, ref, watch, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import { getSalesManAreeTree, saveSalesmanArea, getSalesManCustWhiteList, customerSearch, getBillBranchWhiteList } from '@/request';
import { isNullOrDefined } from '@/utils';
import { SUPPLIER_CATEGORY, getLevelType } from '../../config';
export default {
  name: 'AddSalesmanAreaModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    dept: {
      type: Object,
      default: () => ({})
    },
    supplierId: {
      type: String,
      defualt: ''
    },
    actSalesman: {
      type: [null, Object],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const route = useRoute();
    const storeType = route.query.storeType;
    const store = useStore();
    const accountRoleType = computed(() => store.state.user.userType);
    const showBillBranchWhiteList = computed(() => Number(storeType) === SUPPLIER_CATEGORY['厂家团队'] && Number(accountRoleType.value) === 2);
    const treeData = ref([]);
    const treeRef = ref();
    const defaultCheckKeys = ref([]);
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const loading = ref(false);
    const whitelistLoading = ref(false);
    const whitelistData = ref([]); // 流向查询商业白名单

    const billBranchWhiteListLoading = ref(false);
    const billBranchWhiteListData = ref([]);
    const selectedBillBranchWhiteList = ref([]);
    const billBranchTableRef = ref(null); // 客户选择相关

    const customerSelectVisible = ref(false);
    const customerLoading = ref(false);
    const customerList = ref([]);
    const customerTotal = ref(0);
    const selectedCustomers = ref([]);
    const customerSearchForm = ref({
      page: 1,
      pageSize: 10,
      keyWord: ''
    }); // 白名单删除相关

    const selectedWhitelistCustomers = ref([]);

    function initTreeData() {
      loading.value = true;
      let salesmanAreaCode = props.actSalesman.salesmanAreaCode;
      defaultCheckKeys.value = isNullOrDefined(salesmanAreaCode) ? [] : salesmanAreaCode.split(',');
      getSalesManAreeTree({
        areaLevl: getLevelType(storeType, props.dept),
        currentAdcode: props.dept.busiArea
      }).then(data => {
        if (data !== null && data !== void 0 && data.length) {
          treeData.value = data;
          flattenTreeIdList.value = flattenTreeData(data);
          nextTick(() => {
            if (flattenTreeIdList.value.length === treeRef.value.getCheckedKeys().length) {
              checkAll.value = true;
            } else {
              checkAll.value = false;
            }
          });
        }
      }).finally(() => {
        loading.value = false;
      });
    } // 初始化客户白名单数据


    function initWhitelistData() {
      var _props$actSalesman;

      if (!((_props$actSalesman = props.actSalesman) !== null && _props$actSalesman !== void 0 && _props$actSalesman.supUserId)) return;
      whitelistLoading.value = true;
      getSalesManCustWhiteList({
        supUserId: props.actSalesman.supUserId
      }).then(data => {
        if (data.success && data.rows) {
          whitelistData.value = data.rows;
        } else {
          whitelistData.value = [];
        }
      }).catch(() => {
        whitelistData.value = [];
      }).finally(() => {
        whitelistLoading.value = false;
      });
    }

    function initBillBranchWhiteList(adCode) {
      var _props$actSalesman2;

      if (!((_props$actSalesman2 = props.actSalesman) !== null && _props$actSalesman2 !== void 0 && _props$actSalesman2.supUserId)) return;
      billBranchWhiteListLoading.value = true;
      const params = {
        supUserId: props.actSalesman.supUserId,
        __warn: true
      };

      if (adCode != null && adCode !== '') {
        params.adCode = adCode;
      }

      getBillBranchWhiteList(params).then(res => {
        let {
          success,
          data
        } = res || {};
        billBranchWhiteListData.value = success ? data || [] : [];
        applyBillBranchTableSelectionFromChecked();
      }).catch(() => {
        billBranchWhiteListData.value = [];
      }).finally(() => {
        billBranchWhiteListLoading.value = false;
      });
    }

    function applyBillBranchTableSelectionFromChecked() {
      nextTick(() => {
        const table = billBranchTableRef.value;
        if (!table) return;
        table.clearSelection();
        billBranchWhiteListData.value.forEach(row => {
          if (row.checked === true || row.checked === 1) {
            table.toggleRowSelection(row, true);
          }
        });
      });
    }

    function matchBillBranchByArea() {
      if (!treeRef.value) {
        ElMessage.warning('业务区域树未就绪');
        return;
      }

      const adCodeArr = formatCheckedKeys(treeData.value);

      if (!adCodeArr || adCodeArr.length === 0) {
        ElMessage.warning('请先勾选业务区域');
        return;
      }

      const adCode = adCodeArr.join();
      initBillBranchWhiteList(adCode);
    } // 显示客户选择弹窗


    function showCustomerSelectModal() {
      customerList.value = [];
      customerSelectVisible.value = true;
      customerSearchForm.value = {
        page: 1,
        pageSize: 10,
        keyWord: ''
      };
      selectedCustomers.value = [];
    } // 搜索客户


    function searchCustomers() {
      if (!customerSearchForm.value.keyWord) {
        ElMessage.warning('关键字不能为空');
        return;
      }

      customerLoading.value = true;
      customerSearch(customerSearchForm.value).then(data => {
        if (data.success) {
          customerList.value = data.rows || [];
          customerTotal.value = data.total || 0;
        } else {
          customerList.value = [];
          customerTotal.value = 0;
        }
      }).catch(() => {
        customerList.value = [];
        customerTotal.value = 0;
      }).finally(() => {
        customerLoading.value = false;
      });
    } // 处理客户选择变化


    function handleCustomerSelectionChange(selection) {
      selectedCustomers.value = selection;
    } // 处理白名单客户选择变化


    function handleWhitelistSelectionChange(selection) {
      selectedWhitelistCustomers.value = selection;
    }

    function handleBillBranchWhiteListSelectionChange(selection) {
      selectedBillBranchWhiteList.value = selection;
    } // 删除选中的白名单客户


    function deleteSelectedCustomers() {
      if (selectedWhitelistCustomers.value.length === 0) {
        ElMessage.warning('请选择要删除的客户');
        return;
      } // 从白名单列表中移除选中的客户


      const selectedIds = selectedWhitelistCustomers.value.map(customer => customer.erpCustId);
      whitelistData.value = whitelistData.value.filter(customer => !selectedIds.includes(customer.erpCustId)); // 清空选中状态

      selectedWhitelistCustomers.value = [];
    } // 处理分页大小变化


    function handleSizeChange(size) {
      customerSearchForm.value.pageSize = size;
      customerSearchForm.value.page = 1;
      searchCustomers();
    } // 处理当前页变化


    function handleCurrentChange(page) {
      customerSearchForm.value.page = page;
      searchCustomers();
    } // 确认添加客户到白名单


    function confirmAddCustomers() {
      if (selectedCustomers.value.length === 0) {
        ElMessage.warning('请选择要添加的客户');
        return;
      } // 将选中的客户添加到白名单列表


      const newCustomers = selectedCustomers.value.map(customer => ({
        erpCustId: customer.custId,
        custName: customer.custName,
        areaFullName: customer.provinceName + '.' + customer.cityName + '.' + customer.areaName
      })); // 过滤掉已存在的客户

      const existingCustIds = whitelistData.value.map(item => item.erpCustId);
      const uniqueNewCustomers = newCustomers.filter(customer => !existingCustIds.includes(customer.erpCustId));

      if (uniqueNewCustomers.length === 0) {
        ElMessage.warning('选中的客户已存在于白名单中');
        return;
      }

      whitelistData.value = [...whitelistData.value, ...uniqueNewCustomers];
      customerSelectVisible.value = false;
    }

    watch(() => props.modelValue, newVal => {
      if (newVal) {
        initTreeData();

        if (showBillBranchWhiteList.value) {
          initBillBranchWhiteList();
        } else {
          initWhitelistData();
        }
      }
    });

    function formatCheckedKeys(treeList, targetList = []) {
      let checkedKeys = treeRef.value.getCheckedKeys(); // console.log(checkedKeys)

      let list = [...targetList];
      treeList.forEach(item => {
        if (checkedKeys.find(v => v === item.id)) {
          list.push(item.id);
          return;
        }

        if (item.children && item.children.length) {
          list = list.concat(formatCheckedKeys(item.children));
        }
      });
      return list;
    }

    function confirm() {
      /**
       * 子节点全选，只返回父节点id
       * 省，市，区
       * */
      let adCode = formatCheckedKeys(treeData.value);
      const payload = {
        adCode: adCode.join(),
        structureId: props.dept.id,
        supUserId: props.actSalesman.supUserId,
        supplierId: props.supplierId,
        erpCustIds: showBillBranchWhiteList.value ? '' : whitelistData.value.map(item => item.erpCustId).join(','),
        __repeat: true,
        __warn: true
      };

      if (showBillBranchWhiteList.value) {
        payload.branchIds = selectedBillBranchWhiteList.value.map(r => r.branchId).filter(Boolean).join();
      }

      saveSalesmanArea(payload).then(data => {
        if (data.success) {
          ElMessage.success('操作成功!');
          emit('success');
          visible.value = false;
        }
      });
    } // 全选反选


    const checkAll = ref(false);
    const flattenTreeIdList = ref([]);

    function checkAllHandle(value) {
      if (value) {
        treeRef.value.setCheckedKeys(flattenTreeIdList.value);
      } else {
        treeRef.value.setCheckedKeys([]);
      }
    }

    function treeCheckHandle(current, treeCheckObj) {
      let {
        checkedKeys
      } = treeCheckObj;

      if (checkedKeys.length === flattenTreeIdList.value.length) {
        checkAll.value = true;
      } else {
        checkAll.value = false;
      }
    }

    function flattenTreeData(treeList, targetList = []) {
      let list = [...targetList];
      treeList.forEach(item => {
        list.push(item.id);

        if (item.children && item.children.length) {
          let tmpList = flattenTreeData(item.children);
          list = list.concat(tmpList);
        }
      });
      return list;
    }

    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        title: "选择业务区域",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "1000px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          height: "350px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_checkbox, {
            modelValue: checkAll.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => checkAll.value = $event),
            onChange: checkAllHandle
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 1
          }, 8, ["modelValue"])]), _createVNode(_component_el_tree, {
            data: treeData.value,
            "node-key": "id",
            "show-checkbox": "",
            props: {
              label: 'text',
              value: 'id'
            },
            ref_key: "treeRef",
            ref: treeRef,
            "default-checked-keys": defaultCheckKeys.value,
            onCheck: treeCheckHandle
          }, null, 8, ["data", "default-checked-keys"])]),
          _: 1
        })), [[_directive_loading, loading.value]])]), _unref(showBillBranchWhiteList) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: matchBillBranchByArea
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]), _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          height: "350px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table, {
            ref_key: "billBranchTableRef",
            ref: billBranchTableRef,
            "row-key": "branchId",
            data: billBranchWhiteListData.value,
            style: {
              "width": "100%"
            },
            size: "small",
            onSelectionChange: handleBillBranchWhiteListSelectionChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }), _createVNode(_component_el_table_column, {
              prop: "branchName",
              label: "分销商名称",
              "min-width": "150"
            }), _createVNode(_component_el_table_column, {
              prop: "branchAddress",
              label: "地址",
              "min-width": "200",
              "show-overflow-tooltip": ""
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        })), [[_directive_loading, billBranchWhiteListLoading.value]])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          type: "danger",
          icon: "Delete",
          size: "small",
          onClick: deleteSelectedCustomers,
          disabled: selectedWhitelistCustomers.value.length === 0
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          size: "small",
          onClick: showCustomerSelectModal
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })]), _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          height: "350px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table, {
            data: whitelistData.value,
            style: {
              "width": "100%"
            },
            size: "small",
            onSelectionChange: handleWhitelistSelectionChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }), _createVNode(_component_el_table_column, {
              prop: "custName",
              label: "客户名称",
              "min-width": "150"
            }), _createVNode(_component_el_table_column, {
              prop: "areaFullName",
              label: "客户区域",
              "min-width": "200"
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        })), [[_directive_loading, whitelistLoading.value]])]))])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        title: "选择客户",
        modelValue: customerSelectVisible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => customerSelectVisible.value = $event),
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => customerSelectVisible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_22]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmAddCustomers
        }, {
          default: _withCtx(() => [_hoisted_23]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_input, {
          modelValue: customerSearchForm.value.keyWord,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => customerSearchForm.value.keyWord = $event),
          placeholder: "请输入搜索关键字",
          style: {
            "width": "300px"
          },
          clearable: "",
          onKeyup: _withKeys(searchCustomers, ["enter"])
        }, {
          append: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: searchCustomers,
            icon: "Search"
          }, {
            default: _withCtx(() => [_hoisted_20]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue", "onKeyup"])]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: customerList.value,
          style: {
            "width": "100%"
          },
          size: "small",
          onSelectionChange: handleCustomerSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }), _createVNode(_component_el_table_column, {
            prop: "custName",
            label: "客户名称",
            "min-width": "150"
          }), _createVNode(_component_el_table_column, {
            prop: "address",
            label: "客户地址",
            "min-width": "200",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "custTypeName",
            label: "客户类型",
            "min-width": "120"
          }), _createVNode(_component_el_table_column, {
            prop: "linkMan",
            label: "联系人",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            prop: "linkPhone",
            label: "联系电话",
            "min-width": "120"
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, customerLoading.value]]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_pagination, {
          "current-page": customerSearchForm.value.page,
          "onUpdate:current-page": _cache[4] || (_cache[4] = $event => customerSearchForm.value.page = $event),
          "page-size": customerSearchForm.value.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = $event => customerSearchForm.value.pageSize = $event),
          "page-sizes": [10, 20, 50, 100],
          total: customerTotal.value,
          layout: "total, sizes, prev, pager, next, jumper",
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"])])])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }

};